import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight';

/**
 * Extension du code block standard pour supporter une légende (caption).
 *
 * Quand une caption est présente, le rendu HTML est :
 *   <figure class="article-figure article-figure--code">
 *     <pre><code class="language-xxx">...</code></pre>
 *     <figcaption>Caption ici</figcaption>
 *   </figure>
 *
 * Sans caption, on retombe sur le rendu par défaut <pre><code>...</code></pre>.
 *
 * Convention markdown côté API : une ligne italique seule (`*Caption*`) juste
 * après le code block. Le converter markdownToTiptap.js attache l'attr.
 */
const CodeBlockWithCaption = CodeBlockLowlight.extend({
    addAttributes() {
        return {
            ...this.parent?.() || {},
            caption: {
                default: null,
                parseHTML: element => {
                    // Si le <pre> est dans un <figure>, lire la <figcaption>
                    const parent = element.parentElement;
                    if (parent && parent.tagName === 'FIGURE') {
                        const cap = parent.querySelector('figcaption');
                        return cap ? cap.textContent : null;
                    }
                    return element.getAttribute('data-caption');
                },
                renderHTML: () => ({}),
            },
        };
    },

    renderHTML({ node, HTMLAttributes }) {
        const language = node.attrs.language;
        const codeAttrs = language ? { class: `language-${language}` } : {};
        const codeBlock = ['pre', HTMLAttributes, ['code', codeAttrs, 0]];

        if (node.attrs.caption) {
            return [
                'figure',
                { class: 'article-figure article-figure--code' },
                codeBlock,
                ['figcaption', {}, node.attrs.caption],
            ];
        }

        return codeBlock;
    },
});

export default CodeBlockWithCaption;
